// TODO: Get these from Stripe
export const DEFAULT_PER_EMPLOYEE_COST = 45
export const DEFAULT_COMPLIANCE_FEE = 50

type CoverageLevelOption = {
  value: 'lowest_cost' | 'best_fit' | 'better_benefits',
  label: string,
  description: string,
  disabledTooltip?: string,
}

export const COVERAGE_LEVEL_OPTIONS: CoverageLevelOption[] = [
  {
    value: 'lowest_cost',
    label: 'Lowest cost',
    description: 'Offering basic medical benefits shows employees you care and provides a strong foundation for building a supportive, people-first culture.',
    disabledTooltip: 'Your best fit benchmark is also the cheapest available.',
  },
  {
    value: 'best_fit',
    label: 'Best fit for you',
    description: 'Based on your previous answers, this option is the best for you because:',
  },
  {
    value: 'better_benefits',
    label: 'Better benefits',
    description: 'Offering high-quality medical benefits improves employee retention and helps attract top talent by showing a real investment in their health and well-being.',
    disabledTooltip: 'Your best fit benchmark is also the most generous available.',
  },
]

export const DEPENDENT_COVERAGE_PERCENTAGES = [0, 25, 50, 75, 100]
